import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const contactListEndpoint = ApiEndpoints.contact.contactList;

const tableHeader = ["Date","Name", "phone", "email",  "company Name", "designation", "Location",  "message", "Current Url", "Source Url", "biggest challenge", "solution of interest", "Form Type"];
const tbody = ["createdAt","name", "phone", "email", "company", "designation", "location", "message", "current_url", "source_url", "biggest_challenge", "solution_interest", "form_type"];

export default function Contact() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", contactListEndpoint);
            const result = response.contacts;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const pagename = {
      name: 'Contact Us',
      user: 'Admin',
      innerpage: 'Contact Us'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
